//Paquetes NPM de GYF.
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, ConciergeProxy, SagasHelper, LogsProxy } from 'com-gyf-webcore-servicehub';

//import UsuarioManager from '../../../Common/Managers/UsuarioManager';

//Exportación de constantes
export const SET_FUNCTIONS_LISTA_DE_USUARIOS = 'SET_FUNCTIONS_LISTA_DE_USUARIOS';
export const GET_DATA_LISTA_USUARIOS_START = 'GET_DATA_LISTA_USUARIOS_START';
export const GET_DATA_LISTA_USUARIOS_SUCCESS = 'GET_DATA_LISTA_USUARIOS_SUCCESS';
export const SEARCH_USER_FROM_LISTA_USUARIOS = 'SEARCH_USER_FROM_LISTA_USUARIOS';
export const SET_ACTIVOS_CHECKBOX_FROM_LISTA_USUARIOS = 'SET_ACTIVOS_CHECKBOX_FROM_LISTA_USUARIOS';
export const SET_BLOQUEADOS_CHECKBOX_FROM_LISTA_USUARIOS = 'SET_BLOQUEADOS_CHECKBOX_FROM_LISTA_USUARIOS';
export const SET_ELIMINADOS_CHECKBOX_FROM_LISTA_USUARIOS = 'SET_ELIMINADOS_CHECKBOX_FROM_LISTA_USUARIOS';
export const ORDER_COLUMN_FROM_LISTA_USUARIOS = 'ORDER_COLUMN_FROM_LISTA_USUARIOS';
export const SET_ALL_CHECKBOX_FROM_LISTA_USUARIOS = 'SET_ALL_CHECKBOX_FROM_LISTA_USUARIOS';
export const SET_CHECKBOX_FROM_LISTA_USUARIOS = 'SET_CHECKBOX_FROM_LISTA_USUARIOS';
export const INITIAL_STATE_LISTA_USUARIOS = 'INITIAL_STATE_LISTA_USUARIOS';
export const REINICIAR_CHECKS = 'REINICIAR_CHECKS';
export const GET_DATA_LISTA_USUARIOS_NOT_SUCCESS = 'GET_DATA_LISTA_USUARIOS_NOT_SUCCESS';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

let _dispatch, _currentScope = null;

/**
 * Obtiene los datos para popular la pantalla.
 * @param {any} state
 * @param {any} currentScope
 */
export function getData(executionContext, currentScope) {
    LogHelper.In(getData.name, currentScope);

    return (dispatch, getState) => {
        const state = getState();
        _dispatch = dispatch;
        _currentScope = currentScope;

        dispatch({ type: GET_DATA_LISTA_USUARIOS_START, state, currentUser: _currentScope.UserId , currentUserLogin: executionContext.login});

        var currentScopeRequest = {
            "UserId": _currentScope.UserId,
            "ProductCode": _currentScope.ProductCode,
            "ProgramCode": _currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => getFunctionsCallback(data), null, "GETFUNCTIONS", currentScopeRequest, null, "SEGURIDAD");
    }
}

/**
 * Se filtran los usuarios por texto.
 * @param {any} user
 */
export function searchUser(user) {
    LogHelper.In(searchUser.name, user);
    return (dispatch) => {
        dispatch({ type: SEARCH_USER_FROM_LISTA_USUARIOS, user: user });
    }
}

/**
 * Vuelve el estado de la pantalla al inicial de la misma.
 */
export function resetStateListUser() {

    LogHelper.In(resetStateListUser.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE_LISTA_USUARIOS });
    }
}

/**
 * Se setea el valor del checkbox de activos.
 * @param {any} activo
 */
export function setActivosCheckbox(activo) {
    LogHelper.In(setActivosCheckbox.name, activo);
    return (dispatch) => {
        dispatch({ type: SET_ACTIVOS_CHECKBOX_FROM_LISTA_USUARIOS, activo: activo });
    }
}

/**
 * Se setea el valor del checkbox de activos.
 * @param {any} bloqueado
 */
export function setBloqueadosCheckbox(bloqueado) {
    LogHelper.In(setBloqueadosCheckbox.name, bloqueado);
    return (dispatch) => {
        dispatch({ type: SET_BLOQUEADOS_CHECKBOX_FROM_LISTA_USUARIOS, bloqueado: bloqueado });
    }
}

/**
 * Se setea el valor del checkbox de activos.
 * @param {any} eliminado
 */
export function setEliminadosCheckbox(eliminado) {
    LogHelper.In(setEliminadosCheckbox.name, eliminado);
    return (dispatch) => {
        dispatch({ type: SET_ELIMINADOS_CHECKBOX_FROM_LISTA_USUARIOS, eliminado: eliminado });
    }
}

/**
 * Se ordena la tabla por una columna.
 * @param {any} columnIndex
 */
export function orderColumn(columnIndex) {
    LogHelper.In(orderColumn.name, columnIndex);
    return (dispatch, getState) => {
        dispatch({ type: ORDER_COLUMN_FROM_LISTA_USUARIOS, columnIndex: columnIndex });
    }
}

/**
 * Se setea el valor de todos los checkbox de la tabla.
 * @param {any} allCheckboxFilter
 */
export function setAllCheckbox(allCheckboxFilter, currentUser) {
    LogHelper.In(setAllCheckbox.name, allCheckboxFilter, currentUser);
    return (dispatch) => {
        dispatch({ type: SET_ALL_CHECKBOX_FROM_LISTA_USUARIOS, allCheckboxFilter: allCheckboxFilter, currentUser: currentUser });
    }
}

/**
 * Setea el valor de un checkbox de la tabla.
 * @param {any} usuarioId
 */
export function setCheckbox(usuarioId) {
    LogHelper.In(setCheckbox.name, usuarioId);
    return (dispatch) => {
        dispatch({ type: SET_CHECKBOX_FROM_LISTA_USUARIOS, usuarioId: usuarioId });
    }
}

/**
 * Setea el estado del usuario.
 * @param {any} id
 * @param {any} activo
 * @param {any} bloqueado
 */
export function setUserState(id, activo, bloqueado) {
    //TODO: Simplificar el switch duplicado
    LogHelper.In(setUserState.name, id, activo, bloqueado);

    let caseActive;
    let ruleName;
    let usuariosToUpdateState = [];
    let usuariosToDeleteBlockUnblock = [];
    let localvaluesUpdateUsuarioEstado;
    let localvaluesDeleteBlockUnblockUsuario;

    return (dispatch, getState) => {
        const state = getState();

        if (activo == false) {
            if (bloqueado == false) { caseActive = 1; }
            else { caseActive = 3; }
        } else { if (bloqueado == false) { caseActive = 2; } }

        //dispatch({ type: REINICIAR_CHECKS });


        if (id == undefined || id == null) {
            if (state.listaDeUsuarios.usuariosFiltrados != undefined) {
                state.listaDeUsuarios.usuariosFiltrados.filter(x => x.Seleccionado == true && x.Login != state.listaDeUsuarios.currentUserLogin).forEach(function (item) {
                    localvaluesUpdateUsuarioEstado = {
                        //"ID": item.Id,
                        "USUARIO_ID": item.Id,
                        "ACTIVO": activo
                    }

                    switch (caseActive) {
                        case 1: {
                            ruleName = "DeleteUsuario";
                            localvaluesDeleteBlockUnblockUsuario = { "USUARIO_ID": item.Id, "CURRENT_USER": state.listaDeUsuarios.currentUser, "FECHA_ELIMINADO": null }
                            break;
                        }
                        case 2: {
                            ruleName = "UnlockUsuario";
                            localvaluesDeleteBlockUnblockUsuario = { "USUARIO_ID": item.Id }
                            break;
                        }
                        case 3: {
                            ruleName = "LockUsuario";
                            localvaluesDeleteBlockUnblockUsuario = { "USUARIO_ID": item.Id, "CURRENT_USER": state.listaDeUsuarios.currentUser, "FECHA_BLOQUEADO": null }
                            break;
                        }
                        default: {
                            break;
                        }
                    }

                    usuariosToUpdateState.push(localvaluesUpdateUsuarioEstado);
                    usuariosToDeleteBlockUnblock.push(localvaluesDeleteBlockUnblockUsuario);
                })

                LogHelper.Out(setUserState.name, { UsuariosToDeleteBlockUnblock: usuariosToDeleteBlockUnblock }, ruleName, _currentScope.ProductCode, "SEGURIDAD");
                Engine1Proxy.AddRuleRequests({ UsuariosToDeleteBlockUnblock: usuariosToDeleteBlockUnblock }, ruleName, _currentScope.ProductCode, "SEGURIDAD");

                LogHelper.Out(setUserState.name, { UsuariosToUpdateState: usuariosToUpdateState }, "UpdateUsuarioEstado", _currentScope.ProductCode, "SEGURIDAD");
                Engine1Proxy.AddRuleRequests({ UsuariosToUpdateState: usuariosToUpdateState }, "UpdateUsuarioEstado", _currentScope.ProductCode, "SEGURIDAD");

                Engine1Proxy.Execute((data) => setUserStateCallback(data, usuariosToDeleteBlockUnblock, ruleName, state.listaDeUsuarios.usuarios), null, null, "SEGURIDAD");
            }
        }
        else {
            localvaluesUpdateUsuarioEstado = {
                //"ID": id,
                "USUARIO_ID": id,
                "ACTIVO": activo
            }



            switch (caseActive) {
                case 1: {
                    ruleName = "DeleteUsuario";
                    localvaluesDeleteBlockUnblockUsuario = { "USUARIO_ID": id, "CURRENT_USER": state.listaDeUsuarios.currentUserId, "FECHA_ELIMINADO": null }
                    break;
                }
                case 2: {
                    ruleName = "UnlockUsuario";
                    localvaluesDeleteBlockUnblockUsuario = { "USUARIO_ID": id }
                    break;
                }
                case 3: {
                    ruleName = "LockUsuario";
                    localvaluesDeleteBlockUnblockUsuario = { "USUARIO_ID": id, "CURRENT_USER": state.listaDeUsuarios.currentUserId, "FECHA_BLOQUEADO": null }
                    break;
                }
                default: {
                    break;
                }
            }

            LogHelper.Out(setUserState.name, /*{ UsuariosToDeleteBlockUnblock: usuariosToDeleteBlockUnblock }*/
                localvaluesDeleteBlockUnblockUsuario, ruleName, _currentScope.ProductCode, "SEGURIDAD");
            Engine1Proxy.AddRuleRequests(/*{ UsuariosToDeleteBlockUnblock: usuariosToDeleteBlockUnblock }*/
                localvaluesDeleteBlockUnblockUsuario, ruleName, _currentScope.ProductCode, "SEGURIDAD");

            LogHelper.Out(setUserState.name, /*{ UsuariosToUpdateState: usuariosToUpdateState }*/
                localvaluesUpdateUsuarioEstado, "UpdateUsuarioEstado", _currentScope.ProductCode, "SEGURIDAD");
            Engine1Proxy.AddRuleRequests(/*{ UsuariosToUpdateState: usuariosToUpdateState }*/
                localvaluesUpdateUsuarioEstado, "UpdateUsuarioEstado", _currentScope.ProductCode, "SEGURIDAD");



            let tempList = [];
            tempList.push(localvaluesDeleteBlockUnblockUsuario);

            Engine1Proxy.Execute((data) => setUserStateCallback(data, tempList, ruleName, state.listaDeUsuarios.usuarios), null, null, "SEGURIDAD");
        }
    }
}

/**
 * Setea el motivo de bloqueo del o los usuario seleccionados.
 * @param {any} motivoBloqueo
 */
export function setMotivoBloqueo(motivoBloqueo) {
    LogHelper.In(setMotivoBloqueo.name, motivoBloqueo);

    return (dispatch, getState) => {
        const state = getState();

        let usuariosToEdit = [];

        if (state.listaDeUsuarios.usuariosFiltrados != undefined) {
            state.listaDeUsuarios.usuariosFiltrados.filter(x => x.Seleccionado == true).forEach(function (item) {
                let localvalues = {
                    'USUARIO_ID': item.Id,
                    'MOTIVO_BLOQUEO': motivoBloqueo,
                }

                usuariosToEdit.push(localvalues);
            })
        }

        if (usuariosToEdit.length > 0) {
            LogHelper.Out(setMotivoBloqueo.name, { UsuariosToEdit: usuariosToEdit }, "UpdateUsuarioMotivoBloqueo", _currentScope.ProductCode, "SEGURIDAD");
            Engine1Proxy.AddRuleRequests({ UsuariosToEdit: usuariosToEdit }, "UpdateUsuarioMotivoBloqueo", _currentScope.ProductCode, "SEGURIDAD");
            Engine1Proxy.Execute(setMotivoBloqueoCallback, null, null, "SEGURIDAD");
        } else {
            LogHelper.Out(setMotivoBloqueo.name);
        }
    }
}

/**------------------------------------------------------ FUNCIONES AUXILIARES --------------------------------------------------------**/

//Funcion callback de la obtencion de las funciones del usuario.
function getFunctionsCallback(data) {
    LogHelper.In(getFunctionsCallback.name, data);

    let functions = data.SEGURIDAD;
    functions.forEach(p => { functions[p.Codigo_Funcion] = true; });

    _dispatch({ type: SET_FUNCTIONS_LISTA_DE_USUARIOS, functions });

    if (functions.Consulta == true) {
        LogHelper.Out(getFunctionsCallback.name, null, 'GET_ALL_USUARIOS', 'Get', _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_ALL_USUARIOS', 'Get', _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        Engine1Proxy.Execute(getDataCallback, null, null, "SEGURIDAD");
    } else {
        LogHelper.Out(getFunctionsCallback.name);
        _dispatch({ type: GET_DATA_LISTA_USUARIOS_NOT_SUCCESS });
    }
}

//Funcion callback de la obtencion de los datos principales para popular la pantalla.
function getDataCallback(data) {
    LogHelper.In(getDataCallback.name, data);

    let result = null;

    if (JSON.parse(data.GET_ALL_USUARIOS).Recordset0.Rows != undefined)
        result = JSON.parse(data.GET_ALL_USUARIOS).Recordset0.Rows;

    _dispatch({ type: GET_DATA_LISTA_USUARIOS_SUCCESS, result });
}

//Funcion callback del cambio de estado de un usuario.
function setUserStateCallback(data, userListSelected, ruleName, userList) {
    LogHelper.In(setUserStateCallback.name, data);

    LogUserState(userListSelected, ruleName, userList);

    LogHelper.Out(setUserStateCallback.name, null, 'GET_ALL_USUARIOS', 'Get', _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_ALL_USUARIOS', 'Get', _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.Execute(getDataCallback, null, null, "SEGURIDAD");
}

//Funcion callback del seteo de motivo de bloqueo de un usuario.
function setMotivoBloqueoCallback(data) {
    LogHelper.In(setMotivoBloqueoCallback.name, data);

    LogHelper.Out(setMotivoBloqueoCallback.name, null, 'GET_ALL_USUARIOS', 'Get', _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_ALL_USUARIOS', 'Get', _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.Execute(getDataCallback, null, null, "SEGURIDAD");
}

function LogUserState(userListSelected, ruleName, userList) {

    let action = "";
    let tags = "";


    userListSelected.forEach(function (user) {

        let userData = userList.filter(x => x.Id == user.USUARIO_ID);

        switch (ruleName) {

            case "DeleteUsuario":
                tags = "SEGURIDAD,BAJA,USUARIO";
                action += ("Eliminación del Usuario " + userData[0].Login + " - " + userData[0].Nombre + " ; de la Sucursal: " + userData[0].SUCURSAL + " " + " ; del Sector:  " + userData[0].SECTOR) + " ";
                break;

            case "UnlockUsuario":

                if (userData[0].FechaEliminado) {
                    tags = "SEGURIDAD,REACTIVACION,USUARIO";
                    action += ("Reactivación del Usuario " + userData[0].Login + " - " + userData[0].Nombre + " ; de la Sucursal: " + userData[0].SUCURSAL + " " + " ; del Sector:  " + userData[0].SECTOR) + " ";
                } else {
                    tags = "SEGURIDAD,DESBLOQUEO,USUARIO";
                    action += ("Desbloqueo del Usuario " + userData[0].Login + " - " + userData[0].Nombre + " ; de la Sucursal: " + userData[0].SUCURSAL + " " + " ; del Sector:  " + userData[0].SECTOR) + " ";
                }
                break;

            case "LockUsuario":
                tags = "SEGURIDAD,BLOQUEO,USUARIO";
                action += ("Bloqueo del Usuario " + userData[0].Login + " - " + userData[0].Nombre + " ; de la Sucursal: " + userData[0].SUCURSAL + " " + " ; del Sector:  " + userData[0].SECTOR) + " ";
                break;
        }
    });

    LogsProxy.SaveOperationLog(tags, action, null, null, null, null, null, "SEGURIDAD");
}